import { secureGet } from '../utils/HttpUtils';

export interface ManagementDto {
  id: number;
  code: string;
  label: string;
}

export const getManagements = async () => {
  return secureGet('/v1/private/managements');
};
